// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606171124/js/" + chunkId + "." + {"44":"9d0bea82","225":"1420c773","481":"548eeb33","486":"2066186e","770":"f734d5bd"}[chunkId] + ".0.16182695716173634.chunk.js";
};